import React from 'react';
import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';

/* eslint-disable */
import ErrorPage from '../pages/error';
import PermissionDenied from '../pages/permissionDenied';
/* eslint-enable */

import '../styles/theme.scss';
import LayoutComponent from '../components/Layout';
import Login from '../pages/login';
import { logoutUser } from '../actions/user';
import { useAuth } from '../hooks/auth';
import Geradas from '../pages/cprfs/geradas';
import Ativas from '../pages/cprfs/ativas';
import WorkSheets from '../pages/workSheets';
import Usuarios from '../pages/usuarios/Usuarios';
import ClientList from '../pages/clientList';
import NewCpr from '../pages/cprfs/newCpr';
import Antecipacoes from '../pages/cprfs/antecipacoes';
import AcompanhamentoB3 from '../pages/cprfs/b3/monitoringB3/index';
import Registro from '../pages/cprfs/b3/monitoringB3/Registro';
import HistoryB3 from '../pages/cprfs/b3/b3History/index';
import Historic from '../pages/cprfs/historic';
import Renovacao from '../pages/cprfs/renovacao';
import Resgate from '../pages/cprfs/resgate';
import AguardandoDecisao from '../pages/cprfs/aguardando-decisao';
import Detalhes from '../pages/cprfs/components/detalhes';
import Branches from '../pages/branches';
import BrancheDetails from '../pages/branches/components/brancheDetails';
import ByCpf from '../pages/politicas/byCpf';
import Category from '../pages/politicas/categoria';
import PromoCodes from '../pages/politicas/promoCodes';
import ListaTickets from '../pages/tickets/renovacao';
import SaldoConta from '../pages/tickets/saldoConta';
import Cancelamento from '../pages/tickets/cancelamento';
import DetalhesTicket from '../pages/tickets/components/DetalhesTicket';
import Sentinels from '../pages/sentinel';
import Financeiro from '../pages/financeiro';
import RelatorioDiario from '../pages/relatorio_diario';
import SearchCupons from '../pages/searchCupons';
import Notification from '../pages/comunicacao/notification';
import Reports from '../pages/reports';

import JurosPassivo from '../pages/juros_passivos';
import FinancialIndicators from '../pages/financialIndicators';
import BoiGordoDatAgro from '../pages/boiGordoDatAgro';
import Wellcome from '../pages/wellcome';

import EditCprs from '../pages/cprfs/cprEdit'
import Opportunity from '../pages/cprfs/opportunity';
import ByOpportunity from '../pages/cprfs/byOpportunity';
import PendentesAssinatura from '../pages/cprfs/pendentesAssinatura';

export default function App() {

  const { requireAuth, requirePermission, user } = useAuth();

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route
          path="/"
          element={<LayoutComponent />}
          loader={async () => await requireAuth()}
        >
          <Route index element={<Wellcome />} />

          <Route
            path="branches"
            element={<Branches />}
            loader={async () =>
              await requirePermission(user.routes, "branches")
            }
          />
          <Route
            path="workSheets"
            element={<WorkSheets />}
            loader={async () =>
              await requirePermission(user.routes, "workSheets")
            }
          />
          <Route
            path="usuarios"
            element={<Usuarios />}
            loader={async () =>
              await requirePermission(user.routes, "usuarios")
            }
          />
          <Route
            path="clientList"
            element={<ClientList />}
            loader={async () =>
              await requirePermission(user.routes, "clientList")
            }
          />
          <Route
            path="brancheDetails"
            element={<BrancheDetails />}
            loader={async () =>
              await requirePermission(user.routes, "brancheDetails")
            }
          />

          <Route
            path="sentinels"
            element={<Sentinels />}
            loader={async () =>
              await requirePermission(user.routes, "sentinels")
            }
          />

          <Route path="financeiro">
            <Route
              path="accummulated"
              element={<Financeiro />}
              loader={async () =>
                await requirePermission(user.routes, "financeiro/accummulated")
              }
            />
            <Route
              path="relatorioDiario"
              element={<RelatorioDiario />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "financeiro/relatorioDiario"
                )
              }
            />
            <Route
              path="liquidateCupons"
              element={<SearchCupons liquidate />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "financeiro/liquidateCupons"
                )
              }
            />
            <Route
              path="searchCupons"
              element={<SearchCupons />}
              loader={async () =>
                await requirePermission(user.routes, "financeiro/searchCupons")
              }
            />
            <Route
              path="reports"
              element={<Reports />}
              loader={async () =>
                await requirePermission(user.routes, "financeiro/reports")
              }
            />

            <Route
              path="jurosPassivo"
              element={<JurosPassivo />}
              loader={async () =>
                await requirePermission(user.routes, "financeiro/jurosPassivo")
              }
            />
          </Route>

          <Route path="indicators">
            <Route
              path="financialIndicators"
              element={<FinancialIndicators />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "indicators/financialIndicators"
                )
              }
            />
            <Route
              path="boiGordoDatAgro"
              element={<BoiGordoDatAgro />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "indicators/boiGordoDatAgro"
                )
              }
            />
          </Route>

          <Route path="cprf">
            <Route
              path="geradas"
              element={<Geradas />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/geradas")
              }
            />
            <Route
              path="ativas"
              element={<Ativas />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/ativas")
              }
            />
            <Route
              path="pendentesAssinatura"
              element={<PendentesAssinatura />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/pendentesAssinatura")
              }
            />
            <Route
              path="newCpr"
              element={<NewCpr />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/newCpr")
              }
            />
            <Route
              path="antecipacoes"
              element={<Antecipacoes />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/antecipacoes")
              }
            />
            <Route
              path="opportunity"
              element={<Opportunity />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/opportunity")
              }
            />
            <Route
              path="byOpportunity"
              element={<ByOpportunity />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/byOpportunity")
              }
            />

            <Route
              path="cprEdit"
              element={<EditCprs />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/cprEdit")
              }
            />
            {/* b3 */}
            <Route
              path="acompanhamento_B3"
              element={<AcompanhamentoB3 />}
              loader={async () =>
                await requirePermission(user.routes, "b3/monitoringB3/index")
              }
            />
            <Route
              path="registro_B3"
              element={<Registro />}
              loader={async () =>
                await requirePermission(user.routes, "b3/monitoringB3/Registro")
              }
            />
             <Route
              path="historico_B3"
              element={<HistoryB3 />}
              loader={async () =>
                await requirePermission(user.routes, "b3/history_B3")
              }
            />
            <Route
              path="historic"
              element={<Historic />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/historic")
              }
            />
            <Route
              path="aguardando-decisao"
              element={<AguardandoDecisao />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/aguardando-decisao")
              }
            />
            <Route
              path="renovacao"
              element={<Renovacao />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/renovacao")
              }
            />
            <Route
              path="resgate"
              element={<Resgate />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/resgate")
              }
            />
            <Route
              path="details"
              element={<Detalhes />}
              loader={async () =>
                await requirePermission(user.routes, "cprf/details")
              }
            />
          </Route>

          <Route path="politicas-comerciais">
            <Route
              path="byCpf"
              element={<ByCpf />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "politicas-comerciais/byCpf"
                )
              }
            />
            <Route
              path="category"
              element={<Category />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "politicas-comerciais/category"
                )
              }
            />
            <Route
              path="promoCodes"
              element={<PromoCodes />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "politicas-comerciais/promoCodes"
                )
              }
            />
          </Route>

          <Route path="communication">
            <Route
              path="push-notification"
              element={<Notification />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "communication/push-notification"
                )
              }
            />
          </Route>

          <Route path="ticket">
            <Route
              path="renovacao/listaTickets"
              element={<ListaTickets />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "ticket/renovacao/listaTickets"
                )
              }
            />
            <Route
              path="saldoConta/listaTickets"
              element={<SaldoConta />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "ticket/saldoConta/listaTickets"
                )
              }
            />
            <Route
              path="cancelamento/listaTickets"
              element={<Cancelamento />}
              loader={async () =>
                await requirePermission(
                  user.routes,
                  "ticket/cancelamento/listaTickets"
                )
              }
            />
            <Route
              path="details"
              element={<DetalhesTicket />}
              loader={async () =>
                await requirePermission(user.routes, "ticket/details")
              }
            />
          </Route>
        </Route>

        <Route path="/login" element={<Login />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/permissionDenied" element={<PermissionDenied />} />
        <Route path="*" element={<ErrorPage />} />
      </Route>
    )
  );

  return (
    <RouterProvider router={router} />
  );
}